import { useCallback, useEffect, useRef } from 'react';

interface UseInfiniteScrollOptions {
    loading: boolean;
    hasMore: boolean;
    onLoadMore: () => void;
    threshold?: number;
}

export const useInfiniteScroll = ({
    loading,
    hasMore,
    onLoadMore,
    threshold = 0.8
}: UseInfiniteScrollOptions) => {
    const observer = useRef<IntersectionObserver | undefined>(undefined);

    const lastElementRef = useCallback((node: HTMLElement | null) => {
        if (loading) return;
        
        if (observer.current) observer.current.disconnect();
        
        observer.current = new IntersectionObserver(entries => {
            if (entries[0].isIntersecting && hasMore) {
                onLoadMore();
            }
        }, {
            threshold
        });
        
        if (node) observer.current.observe(node);
    }, [loading, hasMore, onLoadMore, threshold]);

    useEffect(() => {
        return () => {
            if (observer.current) {
                observer.current.disconnect();
            }
        };
    }, []);

    return lastElementRef;
}; 